var _rect, _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_2124_2059)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0004 23.9982L12.0887 20.4262C9.99999 19.5 5.99993 22.5 9.5001 26.5L21.911 35.3872C25.1356 37.2193 29.0875 37.2145 32.3075 35.3744L39.1668 30L39.1668 19.7334H30.7631C30.6512 19.7334 30.5399 19.7401 30.4298 19.7533C29.6882 19.9896 29.0005 20.3864 28.4188 20.9233L27.5374 21.6538L23.767 25.0037C23.0045 25.6811 22.899 26.8342 23.5259 27.6388C24.1891 28.4899 25.4204 28.6339 26.2621 27.9588L30.5321 24.5339C31.1352 24.0501 32.0164 24.1469 32.5001 24.7501C32.9839 25.3532 32.8871 26.2344 32.284 26.7181L28.0141 30.143C25.954 31.7953 22.9404 31.4429 21.3173 29.3598C20.0821 27.7746 20.0086 25.6366 21.0004 23.9982Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 14,
    r: 5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2124_2059",
    x1: 5.54082e-9,
    y1: 0.264664,
    x2: 49.2178,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA3829"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan);
export default __webpack_public_path__ + "static/media/Loan.8a3eed4ce65464805af24b363edcf9b9.svg";
export { ForwardRef as ReactComponent };